<app-navbar></app-navbar>
<div resize-window>
    <div class="container-fluid container-spacing pe-5 margin-top-90">
        <div class="pt-5">
            <div class="container-fluid ps-0 pe-0">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12 ps-0 pe-0">
                        <!-- Navigation Tabs -->
                        <div class="d-flex justify-content-between align-items-center tabs-header-row">
                            <ul class="nav nav-tabs flex-grow-1" role="tablist">
                            <li class="nav-item cursor-pointer">
                                <a class="nav-link" [class.active]="activeTabId === 'shared'" 
                                    (click)="activeTabId = 'shared'" 
                                    role="tab"
                                    data-testid="dashboard.documents.shared-tab">Shared</a>
                            </li>
                            <li class="nav-item cursor-pointer">
                                <a class="nav-link" [class.active]="activeTabId === 'tax'" 
                                    (click)="activeTabId = 'tax'" 
                                    role="tab"
                                    data-testid="dashboard.documents.tax-tab">Tax</a>
                            </li>
                            <li class="nav-item cursor-pointer" *ngIf="currentUser().mfa_enabled && currentUser().is_authy_enabled">
                                <a class="nav-link" [class.active]="activeTabId === 'completed'" 
                                    (click)="activeTabId = 'completed'" 
                                    role="tab"
                                    data-testid="dashboard.documents.completed-tab">Completed</a>
                            </li>
                            <li class="nav-item cursor-pointer" *ngIf="currentUser().firm.show_compliance_documents_folder">
                                <a class="nav-link" [class.active]="activeTabId === 'compliance'" 
                                    (click)="activeTabId = 'compliance'" 
                                    role="tab"
                                    data-testid="dashboard.documents.compliance-tab">Compliance</a>
                            </li>
                        </ul>
                            <button class="btn btn-primary rounded-pill ms-3 flex-shrink-0 upload-doc-btn"
                                (click)="openUploadDocumentModal()"
                                data-testid="dashboard.documents.upload-btn">Upload Document</button>
                        </div>

                        <!-- Tab Content -->
                        <div class="tab-content pt-0">
                            <!-- Shared Documents Tab -->
                            @if (activeTabId === 'shared') {
                                <div class="tab-pane fade show active">
                                    @if ((documentData() | keyvalue).length === 0) {
                                        <div class="text-center py-5">
                                            <p class="text-muted">No records returned</p>
                                        </div>
                                    }
                                    @for (doc of documentData() | keyvalue: orderByDesc; track doc.key; let j = $index) {
                                        <div class="modern-accordion-item mb-2">
                                            <div class="accordion-header cursor-pointer">
                                                <button 
                                                    class="accordion-button"
                                                    [class.collapsed]="!isExpanded('shared-' + j)"
                                                    type="button"
                                                    (click)="toggleAccordion('shared-' + j)"
                                                    [attr.aria-expanded]="isExpanded('shared-' + j)"
                                                    [attr.aria-controls]="'shared-content-' + j"
                                                    [attr.data-testid]="'dashboard.documents.shared-accordion-' + j">
                                                    <strong>{{ doc.key }}</strong>
                                                    <span class="accordion-icon">
                                                        @if (isExpanded('shared-' + j)) {
                                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                        } @else {
                                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                        }
                                                    </span>
                                                </button>
                                            </div>
                                            <div 
                                                class="accordion-content"
                                                [class.expanded]="isExpanded('shared-' + j)"
                                                [attr.id]="'shared-content-' + j">
                                                <div class="accordion-body">
                                                    @for (document of doc.value; track document.id; let i = $index) {
                                                        <div class="document-item p-3 border-bottom" [ngClass]="{'highlight-row':!document.is_read}">
                                                            <div class="row" >
                                                                <div class="col-md-8">
                                                                    <h6><i class="fa fa-file-text-o me-2" aria-hidden="true"></i>{{ document.description }}</h6>
                                                                    <span
                                                                        *ngIf="document.created_by">{{document.created_by.name?document.created_by.name:document.user.name}}
                                                                    </span>
                                                                    <small class="text-muted">{{ document.created_at | date }}</small>
                                                                </div>
                                                                <div class="col-md-4 text-end">
                                                                    <button 
                                                                        class="btn btn-primary btn-sm"
                                                                        (click)="openDocument(document, doc.key, i, 'shared')"
                                                                        [attr.data-testid]="'dashboard.documents.shared-view-btn-' + document.id">
                                                                        View Document
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            <!-- Tax Documents Tab -->
                            @if (activeTabId === 'tax') {
                                <div class="tab-pane fade show active">
                                    <div class="row" *ngIf="!currentUser().mfa_enabled || !currentUser().is_authy_enabled">
                                        <div class="container col-md-12 mt-5 text-center">In order to see your Tax Documents, you must have Two-Factor Authentication enabled.</div>
                                    </div>
                                    @if (currentUser().mfa_enabled && currentUser().is_authy_enabled && (taxDocumentData() | keyvalue).length === 0) {
                                        <div class="text-center py-5">
                                            <p class="text-muted">No records returned</p>
                                        </div>
                                    }
                                    @for (doc of taxDocumentData() | keyvalue: orderByDesc; track doc.key; let i = $index) {
                                        <div class="modern-accordion-item mb-2">
                                            <div class="accordion-header cursor-pointer">
                                                <button 
                                                    class="accordion-button"
                                                    [class.collapsed]="!isExpanded('tax-' + i)"
                                                    type="button"
                                                    (click)="toggleAccordion('tax-' + i)"
                                                    [attr.aria-expanded]="isExpanded('tax-' + i)"
                                                    [attr.aria-controls]="'tax-content-' + i"
                                                    [attr.data-testid]="'dashboard.documents.tax-accordion-' + i">
                                                    <strong>Tax Year {{ doc.key }}</strong>
                                                    <span class="accordion-icon">
                                                        @if (isExpanded('tax-' + i)) {
                                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                        } @else {
                                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                        }
                                                    </span>
                                                </button>
                                            </div>
                                            <div 
                                                class="accordion-content"
                                                [class.expanded]="isExpanded('tax-' + i)"
                                                [attr.id]="'tax-content-' + i">
                                                <div class="accordion-body">
                                                    @for (document of doc.value; track document.id; let j = $index) {
                                                        <div class="document-item p-3 border-bottom" [ngClass]="{'highlight-row':!document.is_read}">
                                                            <div class="row" >
                                                                <div class="col-md-8">
                                                                    <h6><i class="fa fa-file-text-o me-2" aria-hidden="true"></i>{{ document.description }}</h6>
                                                                    <small class="text-muted">{{ document.created_at | date }}</small>
                                                                    <span
                                                                        *ngIf="document.created_by">{{document.created_by.name?document.created_by.name:document.user.name}}
                                                                    </span>
                                                                </div>
                                                                <div class="col-md-4 text-end">
                                                                    <button 
                                                                        class="btn btn-primary btn-sm"
                                                                        (click)="openDocument(document, doc.key, j, 'tax')"
                                                                        [attr.data-testid]="'dashboard.documents.tax-view-btn-' + document.id">
                                                                        View Document
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            <!-- Completed Documents Tab -->
                            @if (currentUser().mfa_enabled && currentUser().is_authy_enabled) {
                            @if (activeTabId === 'completed') {
                                <div class="tab-pane fade show active">
                                    @if ((completedDocumentData() | keyvalue).length === 0) {
                                        <div class="text-center py-5">
                                            <p class="text-muted">No records returned</p>
                                        </div>
                                    }
                                    @for (doc of completedDocumentData() | keyvalue: orderByDesc; track doc.key; let i = $index) {
                                        <div class="modern-accordion-item mb-2">
                                            <div class="accordion-header cursor-pointer">
                                                <button 
                                                    class="accordion-button"
                                                    [class.collapsed]="!isExpanded('completed-' + i)"
                                                    type="button"
                                                    (click)="toggleAccordion('completed-' + i)"
                                                    [attr.aria-expanded]="isExpanded('completed-' + i)"
                                                    [attr.aria-controls]="'completed-content-' + i"
                                                    [attr.data-testid]="'dashboard.documents.completed-accordion-' + i">
                                                    <strong>{{ doc.key }}</strong>
                                                    <span class="accordion-icon">
                                                        @if (isExpanded('completed-' + i)) {
                                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                        } @else {
                                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                        }
                                                    </span>
                                                </button>
                                            </div>
                                            <div 
                                                class="accordion-content"
                                                [class.expanded]="isExpanded('completed-' + i)"
                                                [attr.id]="'completed-content-' + i">
                                                <div class="accordion-body">
                                                    @for (document of doc.value; track document.id; let j = $index) {
                                                        <div class="document-item p-3 border-bottom" [ngClass]="{'highlight-row':!document.is_read}">
                                                            <div class="row" >
                                                                <div class="col-md-8">
                                                                    <h6><i class="fa fa-file-text-o me-2" aria-hidden="true"></i>{{ document.description }}</h6>
                                                                    <div class="d-flex justify-content-between">
                                                                        <small class="text-muted">{{ document.created_at | date }}</small>
                                                                        <span
                                                                            *ngIf="document.created_by">{{document.created_by.name?document.created_by.name:document.user.name}}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-4 text-end">
                                                                    <button 
                                                                        class="btn btn-primary btn-sm"
                                                                        (click)="openDocument(document, doc.key, j, 'completed')"
                                                                        [attr.data-testid]="'dashboard.documents.completed-view-btn-' + document.id">
                                                                        View Document
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            }

                            <!-- Compliance Documents Tab -->
                            @if (activeTabId === 'compliance') {
                                <div class="tab-pane fade show active">
                                    @if (complianceDocumentData().length === 0) {
                                        <div class="text-center py-5">
                                            <p class="text-muted">No records returned</p>
                                        </div>
                                    }
                                    @if (complianceDocumentData().length > 0) {
                                        <div class="card w-100">
                                            <div class="card-body p-1">
                                                @for (documentValue of complianceDocumentData(); track $index) {
                                                    <div class="document-item p-2 border-bottom">
                                                        <div class="row pt-2" >
                                                            <div class="col-md-8">
                                                                <h6><i class="fa fa-file-text-o me-2" aria-hidden="true"></i>{{ documentValue.description }}</h6>
                                                              
                                                            </div>
                                                            <div class="col-md-4 text-end">
                                                                <button 
                                                                    class="btn btn-primary btn-sm"
                                                                    (click)="openComplianceDocument(documentValue.url)"
                                                                    [attr.data-testid]="'dashboard.documents.compliance-view-btn-' + $index">
                                                                    View Document
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
